import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { addPackagingData } from '../actions/package';
import { addProviders } from '../actions/providers';
import { uiChangeSkladName, uiChangeUsersAvatars } from '../actions/ui';
import { addUser } from '../actions/user';
import ProviderInfoApi from '../API/provider/providerInfo-api';
import PackageApi from '../API/shipment/package-api';
import UserApi from '../API/user/user-api';
import { SidebarBlue } from '../components/Basic/Global';
import { POP_UP_CONTAINER_ID, SKLADS_WAREHOUSE_MAP } from '../constans';
import LoginPage from '../pages/Auth/Login';
import { GlobalRouter } from './routes';

function MainRouter() {
  const user = useSelector((store) => store.user);
  const skladName = useSelector((store) => store.ui.skladName);
  const [isLoaded, setIsLoaded] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { role } = user;

  const getMainInfo = async () => {
    const version = await UserApi.getVersion({}).then(r => r.version)
    dispatch({ type: 'set_service_version', version });
    setIsLoaded(true)
    if (user.auth) {
      const r = await UserApi.checkSession({});
      dispatch(addUser(r.user));
      await UserApi.getUsersAvatar({}).then((r) => dispatch(uiChangeUsersAvatars(r.userAvatarMap)));
      await ProviderInfoApi.getAll({}).then((r) => dispatch(addProviders(r.providers)));
      await PackageApi.getAll({}).then((r) => dispatch(addPackagingData(r.data)));
    }
  };


  useEffect(() => {
    getMainInfo();
    if (!skladName) {
      let access_city = user.sklads.ekb ? 'ekb' : 'msk';
      dispatch(uiChangeSkladName(SKLADS_WAREHOUSE_MAP[access_city]));
    }
  }, [user.auth]);

  return (
    isLoaded ?
      <>
        <div id={POP_UP_CONTAINER_ID} />
        {user.auth ? (
          <>
            <SidebarBlue />
            <Routes>
              <Route path="/shipment/*" element={<GlobalRouter.ShipmentRouter />} />
              <Route path="/fbo/*" element={<GlobalRouter.FboRouter />} />
              <Route path="/market/*" element={<GlobalRouter.MarketRouter />} />
              <Route path="/orders/*" element={<GlobalRouter.OrdersRouter />} />
              <Route path="/provider/*" element={<GlobalRouter.ProviderRouter />} />
              <Route path="/warehouse/*" element={<GlobalRouter.WarhouseRouter />} />
              <Route path="/report/*" element={<GlobalRouter.ReportRouter />} />
              <Route path="/control/*" element={<GlobalRouter.ControlRouter />} />
              <Route path="/settings/*" element={<GlobalRouter.SettingsAdminRouter />} />
              <Route path="/user/*" element={<GlobalRouter.UserRouter />} />
              <Route path="/statistic/*" element={<GlobalRouter.StatisticRouter />} />
              <Route path="*" element={<Navigate to='/user/profile' replace />} />
            </Routes>
          </>
        ) : (
          <Routes>
            <Route path={'/login'} element={<LoginPage />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        )}
      </> :
      <></>
  );
}

export default MainRouter;
